/**
 * Calls `onEnter` once, the first time `el` is at least `threshold` visible.
 *
 * Owns: one observer per watched element, released on first entry or by the
 * returned stop. Not `reveal.ts`'s shared observer: that one only adds a class
 * to `[data-reveal]` targets, and a counter needs a callback. Without
 * `IntersectionObserver` the callback fires at once, so a figure is never
 * stuck at zero.
 */
export function onEnterView(el: Element, onEnter: () => void, threshold = 0.4): () => void {
  if (typeof IntersectionObserver === 'undefined') {
    onEnter();
    return () => undefined;
  }
  const observer = new IntersectionObserver(
    (entries) => {
      if (!entries.some((e) => e.isIntersecting)) return;
      observer.disconnect();
      onEnter();
    },
    { threshold },
  );
  observer.observe(el);
  return () => observer.disconnect();
}
